import React from 'react';
import SeedAuthenticationRepository from '../repository/SeedAuthenticationRepository';
import seedThemeLight from '../theme/seed-theme-light';
import seedThemeDark from '../theme/seed-theme-dark';
import { APP_THEME_LIGHT, APP_THEME_DARK } from '../theme/theme-constants';
import SeedNotFoundPage from '../page/SeedNotFoundPage';
import { seedSupportedLocales, seedDefaultLocale } from '../intl/seed-intl';
import { seedSupportedThemes, seedDefaultTheme } from '../theme/seed-themes';
import {
  seedSupportedFonts, seedDefaultFont, seedDefaultFontSize, seedSupportedFontSizes,
} from '../font/seed-fonts';
import seedRoutes from '../route/seed-routes';
import SeedLoadingPage from '../page/SeedLoadingPage';
import { seedAppIcons } from '../icon/seed-icons';
import { seedStateDefaultStates } from '../state/seed-states';
import seedDrawerRoutes from '../route/seed-drawer-routes';
import seedLogo from '../images/logo.svg';

const defaultAppConfigPropTypes = {
  // internationalization.
  intlDefaultLocale: seedDefaultLocale,
  intlSupportedLocales: seedSupportedLocales,
  intlMessageLocales: {
    en: {},
    id: {},
  },
  intlMessageSeedLocales: {},
  intlExtraMessageLocales: {
    en: [],
    id: [],
  },

  // theme
  themeDefaultTheme: seedDefaultTheme,
  themeSupportedThemes: seedSupportedThemes,
  themeThemes: {
    [APP_THEME_LIGHT]: seedThemeLight,
    [APP_THEME_DARK]: seedThemeDark,
  },

  // Font
  fontDefaultFont: seedDefaultFont,
  fontSupportedFonts: seedSupportedFonts,
  fontDefaultFontSize: seedDefaultFontSize,
  fontSupportedFontSizes: seedSupportedFontSizes,

  // state
  stateAppStates: {},
  stateDefaultAppStates: seedStateDefaultStates,

  // Route
  appRoutes: seedRoutes,
  AuthenticationRepository: SeedAuthenticationRepository,
  notFoundPage: <SeedNotFoundPage />,
  loadingPage: <SeedLoadingPage />,
  applicationName: 'react-seed',
  commonComponentProps: {
    drawerRoutes: seedDrawerRoutes,
    AuthenticationRepository: SeedAuthenticationRepository,
    applicationName: 'react-seed',
    logo: seedLogo,
    icons: seedAppIcons,
  },
  icons: seedAppIcons,
};

export default defaultAppConfigPropTypes;
